import { Column, Icon, Row, Text } from "@amzn/meridian";
import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { COLORS } from "src/constants/colors";
import { getInspectionById } from "src/store/dataSlice";
import { useAppDispatch, useAppSelector } from "src/store/store";
import chevronLeftLargeTokens from "@amzn/meridian-tokens/base/icon/chevron-left-large";

const CompletedInspectionDetails = () => {
  const { selectedInspectionDetail } = useAppSelector((state) => state.data);
  const { inspectionId } = useParams();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  useEffect(() => {
    if (!inspectionId) return;
    dispatch(getInspectionById(inspectionId));
  }, [inspectionId]);
  return (
    <Column
      className="questions-page"
      minHeight="100vh"
      alignmentVertical="justify"
      backgroundColor={COLORS.DARKER_WHITE}
    >
      <Column>
        <Column
          width="100%"
          backgroundColor={COLORS.WHITE}
          spacingInset="600 500 400"
        >
          <Row>
            <div
              style={{ cursor: "pointer", marginLeft: "50px" }}
              onClick={() => navigate("/completedInspections")}
            >
              <Icon tokens={chevronLeftLargeTokens} color="primary" />
            </div>
          </Row>
          <Column>
            <Row>
              <Text type="b500">{selectedInspectionDetail.templateName}</Text>
            </Row>
          </Column>
        </Column>
        <Column width="100%" spacingInset="none 500">
          <Text type="b500">Inspection details Page placeholder </Text>
        </Column>
      </Column>
    </Column>
  );
};

export default CompletedInspectionDetails;
